export const state = {
  ordersFiltersConfig: null,
  inventoryFiltersConfig: null,
  receptionsFiltersConfig: null,
  workOrdersFiltersConfig: null,
  dashboardPricesFiltersConfig: null,
  dynamicConfigs: null,
  paginationConfig: null,
  applicationConfig: null,
};

const defaultConfigs = {
  inventoryFiltersConfig: {
    selectedStatus: [],
  },
  workOrdersFiltersConfig: {
    selectedStatus: [],
    listType: 'columns',
  },
  ordersFiltersConfig: {
    showClosed: false,
    selectedStatus: [],
    selectedSuppliers: [],
  },
  dashboardPricesFiltersConfig: {
    showNoPrice: false,
  },
  receptionsFiltersConfig: {
    selectedStatus: [],
    selectedSuppliers: [],
  },
  dynamicConfigs: {},
  gridConfig: {
    itemsPerPage: 10,
    hiddenColumns: [],
  },
  applicationConfig: {
    lastCodeDismissed: '',
  },
};

export const mutations = {
  mutateByCode(state, { code, config }) {
    state[code] = config;
    localStorage.setItem(code, JSON.stringify(config));
  },
};

export const actions = {
  setByCode({ commit }, payload) {
    commit('mutateByCode', payload);
  },
  setDynamicConfig({ getters, commit }, { code, config }) {
    commit('mutateByCode', {
      code: 'dynamicConfigs',
      config: {
        ...getters.getDynamicConfigs(),
        [code]: config,
      },
    });
  },
};

export const getters = {
  getByCode: (state) => (configCode) => {
    let defaultValues = defaultConfigs[configCode];
    let savedValues = state[configCode];

    if (savedValues == null) {
      let localStorageConfig = localStorage.getItem(configCode);
      if (localStorageConfig != null) {
        savedValues = JSON.parse(localStorageConfig);
      }
    }

    return { ...defaultValues, ...savedValues };
  },
  getDynamicConfigs: (state, getters) => (code = null) => {
    let dynamicConfigs = getters.getByCode('dynamicConfigs');
    if (code != null) {
      if (code in dynamicConfigs) {
        return dynamicConfigs[code];
      } else {
        let defaultConfigCode = code.split('-')[0];
        return defaultConfigs[defaultConfigCode];
      }
    }

    return dynamicConfigs;
  },
};
